export const sectionAutoLinkComponentModule = angular
  .module('Q.components.section-auto-link', [])
  .directive('section', function SectionAutoLink($window) {
    return {
      restrict: 'E',
      link(scope, elem, attr) {
        if (!attr.id || attr.noSectionLink !== undefined) return;
        let header = elem.find('h1').eq(0);
        if (!header.length) return;
        let link = angular.element(
          '<a class="section-link" title="Link directly to this section.">',
        );
        link.attr('href', '#' + $window.encodeURIComponent(attr.id));
        header.prepend(link);
      },
    };
  });
